<template>
  <b-overlay
    :show="show"
    spinner-variant="primary"
    spinner-type="grow"
    spinner-small
    rounded="sm"
  >
    <b-card :title="$t('investors')">
      <b-row>
        <b-col
          v-if="account.nick_name"
          cols="12"
          class="mb-1"
        >
          {{ $t('investors_list_description', { name: account.nick_name }) }}
        </b-col>
        <b-col cols="12">
          <b-table
            :items="investors"
            :fields="investorFields"
            striped
            responsive
            show-empty
            :empty-text="$t('no_investors')"
            sticky-header="1000px"
          >
            <template
              v-for="key in dateKeys"
              #[`cell(${key})`]="data"
            >
              <span :key="key">{{ getFormattedDate(data.item[key]) }}</span>
            </template>
          </b-table>
        </b-col>
      </b-row>
    </b-card>
  </b-overlay>
</template>

<script>
import {
  BOverlay,
  BCard,
  BRow,
  BCol,
  BTable,
} from 'bootstrap-vue'
import moment from '@/libs/moment'
import PammApis from '@/modules/pamm/service/apis'

const pammApis = new PammApis()

const getResults = res => {
  const { results } = res.data
  return Array.isArray(results) ? results : (results?.data ?? [])
}

export default {
  components: {
    BOverlay,
    BCard,
    BRow,
    BCol,
    BTable,
  },
  data() {
    return {
      show: false,
      account: {},
      investors: [],
    }
  },
  computed: {
    investorFields() {
      if (!this.investors.length) return []
      return Object.keys(this.investors[0])
        .filter(key => this.investors[0][key] === null || typeof this.investors[0][key] !== 'object')
        .map(key => ({
          key,
          label: this.$te(key) ? this.$t(key) : key.replace(/_/g, ' '),
        }))
    },
    dateKeys() {
      return this.investorFields.map(field => field.key).filter(key => /(_at|_time)$/.test(key))
    },
  },
  mounted() {
    this.getData()
  },
  methods: {
    async getData() {
      this.show = true
      const { id } = this.$route.params
      await Promise.all([
        pammApis.getManagerAccounts(id).then(res => {
          this.investors = getResults(res)
        }),
        pammApis.getManagerList().then(res => {
          this.account = getResults(res).find(item => String(item.id) === String(id)) ?? {}
        }),
      ]).catch(err => {
        console.log(err)
      }).finally(() => {
        this.show = false
      })
    },
    getFormattedDate(date) {
      return date ? moment(date).format('YYYY-MM-DD HH:mm:ss') : '-'
    },
  },
}
</script>
